/* eslint-disable */

// @ts-nocheck

// biome-ignore-all lint: generated by @tanstack/router-plugin

// biome-ignore-all assist/source/organizeImports: generated by @tanstack/router-plugin

// biome-ignore-all format: generated by @tanstack/router-plugin

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as CreateAccountRouteImport } from "./routes/create-account";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated/index";
import { Route as AuthenticatedAtChar123usernameChar125RouteImport } from "./routes/_authenticated/@{$username}";
import { Route as AuthenticatedAgentsRouteImport } from "./routes/_authenticated/agents";
import { Route as AuthenticatedDeviceRouteImport } from "./routes/_authenticated/device";
import { Route as AuthenticatedEarningsRouteImport } from "./routes/_authenticated/earnings";
import { Route as AuthenticatedEvalsRouteImport } from "./routes/_authenticated/evals";
import { Route as AuthenticatedGamesRouteImport } from "./routes/_authenticated/games";
import { Route as AuthenticatedLedgerRouteImport } from "./routes/_authenticated/ledger";
import { Route as AuthenticatedModelsRouteImport } from "./routes/_authenticated/models";
import { Route as AuthenticatedModerationRouteImport } from "./routes/_authenticated/moderation";
import { Route as AuthenticatedSearchRouteImport } from "./routes/_authenticated/search";
import { Route as AuthenticatedStaffRouteImport } from "./routes/_authenticated/staff";
import { Route as AuthenticatedViewportLabRouteImport } from "./routes/_authenticated/viewport-lab";
import { Route as AccountDeletedRouteImport } from "./routes/account.deleted";
import { Route as CheckoutAppReturnRouteImport } from "./routes/checkout.app-return";
import { Route as AuthenticatedAccountDeletionRouteImport } from "./routes/_authenticated/account.deletion";
import { Route as AuthenticatedAssetsIndexRouteImport } from "./routes/_authenticated/assets.index";
import { Route as AuthenticatedAssetsMineRouteImport } from "./routes/_authenticated/assets.mine";
import { Route as AuthenticatedInvitesCodeRouteImport } from "./routes/_authenticated/invites.$code";
import { Route as AuthenticatedPlayGameIdRouteImport } from "./routes/_authenticated/play.$gameId";
import { Route as AuthenticatedPresetsMineRouteImport } from "./routes/_authenticated/presets.mine";
import { Route as AuthenticatedProfilesProfileIdRouteImport } from "./routes/_authenticated/profiles.$profileId";
import { Route as AuthenticatedSettingsChar123SectionChar125RouteImport } from "./routes/_authenticated/settings.{-$section}";
import { Route as AuthenticatedAssetsAssetIdIndexRouteImport } from "./routes/_authenticated/assets.$assetId.index";
import { Route as AuthenticatedAssetsCollectionsIndexRouteImport } from "./routes/_authenticated/assets.collections.index";
import { Route as AuthenticatedAssetsCollectionsCollectionIdRouteImport } from "./routes/_authenticated/assets.collections.$collectionId";
import { Route as AuthenticatedAssetsCollectionsMineRouteImport } from "./routes/_authenticated/assets.collections.mine";
import { Route as AuthenticatedPlayGameIdDebugRouteImport } from "./routes/_authenticated/play_.$gameId.debug";
import { Route as AuthenticatedPresetsSlugIndexRouteImport } from "./routes/_authenticated/presets.$slug.index";
import { Route as AuthenticatedPresetsSlugEditRouteImport } from "./routes/_authenticated/presets.$slug.edit";
import { Route as AuthenticatedPresetsSlugNewRouteImport } from "./routes/_authenticated/presets.$slug.new";
import { Route as AuthenticatedPresetsSlugStillRouteImport } from "./routes/_authenticated/presets.$slug.still";
import { Route as AuthenticatedAssetsKindSlugIndexRouteImport } from "./routes/_authenticated/assets.$kind.$slug.index";
import { Route as AuthenticatedAssetsIdAssetIdEditRouteImport } from "./routes/_authenticated/assets.id.$assetId.edit";
import { Route as AuthenticatedAssetsIdAssetIdDraftsVersionIdRouteImport } from "./routes/_authenticated/assets.id.$assetId.drafts.$versionId";

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const CreateAccountRoute = CreateAccountRouteImport.update({
  id: "/create-account",
  path: "/create-account",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedAtChar123usernameChar125Route =
  AuthenticatedAtChar123usernameChar125RouteImport.update({
    id: "/@{$username}",
    path: "/@{$username}",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAgentsRoute = AuthenticatedAgentsRouteImport.update({
  id: "/agents",
  path: "/agents",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedDeviceRoute = AuthenticatedDeviceRouteImport.update({
  id: "/device",
  path: "/device",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedEarningsRoute = AuthenticatedEarningsRouteImport.update({
  id: "/earnings",
  path: "/earnings",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedEvalsRoute = AuthenticatedEvalsRouteImport.update({
  id: "/evals",
  path: "/evals",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedGamesRoute = AuthenticatedGamesRouteImport.update({
  id: "/games",
  path: "/games",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedLedgerRoute = AuthenticatedLedgerRouteImport.update({
  id: "/ledger",
  path: "/ledger",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedModelsRoute = AuthenticatedModelsRouteImport.update({
  id: "/models",
  path: "/models",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedModerationRoute = AuthenticatedModerationRouteImport.update({
  id: "/moderation",
  path: "/moderation",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSearchRoute = AuthenticatedSearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedStaffRoute = AuthenticatedStaffRouteImport.update({
  id: "/staff",
  path: "/staff",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedViewportLabRoute =
  AuthenticatedViewportLabRouteImport.update({
    id: "/viewport-lab",
    path: "/viewport-lab",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AccountDeletedRoute = AccountDeletedRouteImport.update({
  id: "/account/deleted",
  path: "/account/deleted",
  getParentRoute: () => rootRouteImport,
} as any);
const CheckoutAppReturnRoute = CheckoutAppReturnRouteImport.update({
  id: "/checkout/app-return",
  path: "/checkout/app-return",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedAccountDeletionRoute =
  AuthenticatedAccountDeletionRouteImport.update({
    id: "/account/deletion",
    path: "/account/deletion",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsIndexRoute =
  AuthenticatedAssetsIndexRouteImport.update({
    id: "/assets/",
    path: "/assets/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsMineRoute = AuthenticatedAssetsMineRouteImport.update({
  id: "/assets/mine",
  path: "/assets/mine",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedInvitesCodeRoute =
  AuthenticatedInvitesCodeRouteImport.update({
    id: "/invites/$code",
    path: "/invites/$code",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlayGameIdRoute = AuthenticatedPlayGameIdRouteImport.update({
  id: "/play/$gameId",
  path: "/play/$gameId",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedPresetsMineRoute =
  AuthenticatedPresetsMineRouteImport.update({
    id: "/presets/mine",
    path: "/presets/mine",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedProfilesProfileIdRoute =
  AuthenticatedProfilesProfileIdRouteImport.update({
    id: "/profiles/$profileId",
    path: "/profiles/$profileId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsChar123SectionChar125Route =
  AuthenticatedSettingsChar123SectionChar125RouteImport.update({
    id: "/settings/{-$section}",
    path: "/settings/{-$section}",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsAssetIdIndexRoute =
  AuthenticatedAssetsAssetIdIndexRouteImport.update({
    id: "/assets/$assetId/",
    path: "/assets/$assetId/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsCollectionsIndexRoute =
  AuthenticatedAssetsCollectionsIndexRouteImport.update({
    id: "/assets/collections/",
    path: "/assets/collections/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsCollectionsCollectionIdRoute =
  AuthenticatedAssetsCollectionsCollectionIdRouteImport.update({
    id: "/assets/collections/$collectionId",
    path: "/assets/collections/$collectionId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsCollectionsMineRoute =
  AuthenticatedAssetsCollectionsMineRouteImport.update({
    id: "/assets/collections/mine",
    path: "/assets/collections/mine",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlayGameIdDebugRoute =
  AuthenticatedPlayGameIdDebugRouteImport.update({
    id: "/play_/$gameId/debug",
    path: "/play/$gameId/debug",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPresetsSlugIndexRoute =
  AuthenticatedPresetsSlugIndexRouteImport.update({
    id: "/presets/$slug/",
    path: "/presets/$slug/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPresetsSlugEditRoute =
  AuthenticatedPresetsSlugEditRouteImport.update({
    id: "/presets/$slug/edit",
    path: "/presets/$slug/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPresetsSlugNewRoute =
  AuthenticatedPresetsSlugNewRouteImport.update({
    id: "/presets/$slug/new",
    path: "/presets/$slug/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPresetsSlugStillRoute =
  AuthenticatedPresetsSlugStillRouteImport.update({
    id: "/presets/$slug/still",
    path: "/presets/$slug/still",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsKindSlugIndexRoute =
  AuthenticatedAssetsKindSlugIndexRouteImport.update({
    id: "/assets/$kind/$slug/",
    path: "/assets/$kind/$slug/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsIdAssetIdEditRoute =
  AuthenticatedAssetsIdAssetIdEditRouteImport.update({
    id: "/assets/id/$assetId/edit",
    path: "/assets/id/$assetId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute =
  AuthenticatedAssetsIdAssetIdDraftsVersionIdRouteImport.update({
    id: "/assets/id/$assetId/drafts/$versionId",
    path: "/assets/id/$assetId/drafts/$versionId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute;
  "/create-account": typeof CreateAccountRoute;
  "/login": typeof LoginRoute;
  "/@{$username}": typeof AuthenticatedAtChar123usernameChar125Route;
  "/agents": typeof AuthenticatedAgentsRoute;
  "/device": typeof AuthenticatedDeviceRoute;
  "/earnings": typeof AuthenticatedEarningsRoute;
  "/evals": typeof AuthenticatedEvalsRoute;
  "/games": typeof AuthenticatedGamesRoute;
  "/ledger": typeof AuthenticatedLedgerRoute;
  "/models": typeof AuthenticatedModelsRoute;
  "/moderation": typeof AuthenticatedModerationRoute;
  "/search": typeof AuthenticatedSearchRoute;
  "/staff": typeof AuthenticatedStaffRoute;
  "/viewport-lab": typeof AuthenticatedViewportLabRoute;
  "/account/deleted": typeof AccountDeletedRoute;
  "/checkout/app-return": typeof CheckoutAppReturnRoute;
  "/account/deletion": typeof AuthenticatedAccountDeletionRoute;
  "/assets/mine": typeof AuthenticatedAssetsMineRoute;
  "/invites/$code": typeof AuthenticatedInvitesCodeRoute;
  "/play/$gameId": typeof AuthenticatedPlayGameIdRoute;
  "/presets/mine": typeof AuthenticatedPresetsMineRoute;
  "/profiles/$profileId": typeof AuthenticatedProfilesProfileIdRoute;
  "/settings/{-$section}": typeof AuthenticatedSettingsChar123SectionChar125Route;
  "/assets/": typeof AuthenticatedAssetsIndexRoute;
  "/assets/collections/$collectionId": typeof AuthenticatedAssetsCollectionsCollectionIdRoute;
  "/assets/collections/mine": typeof AuthenticatedAssetsCollectionsMineRoute;
  "/play/$gameId/debug": typeof AuthenticatedPlayGameIdDebugRoute;
  "/presets/$slug/edit": typeof AuthenticatedPresetsSlugEditRoute;
  "/presets/$slug/new": typeof AuthenticatedPresetsSlugNewRoute;
  "/presets/$slug/still": typeof AuthenticatedPresetsSlugStillRoute;
  "/assets/$assetId/": typeof AuthenticatedAssetsAssetIdIndexRoute;
  "/assets/collections/": typeof AuthenticatedAssetsCollectionsIndexRoute;
  "/presets/$slug/": typeof AuthenticatedPresetsSlugIndexRoute;
  "/assets/id/$assetId/edit": typeof AuthenticatedAssetsIdAssetIdEditRoute;
  "/assets/$kind/$slug/": typeof AuthenticatedAssetsKindSlugIndexRoute;
  "/assets/id/$assetId/drafts/$versionId": typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute;
}
export interface FileRoutesByTo {
  "/create-account": typeof CreateAccountRoute;
  "/login": typeof LoginRoute;
  "/@{$username}": typeof AuthenticatedAtChar123usernameChar125Route;
  "/agents": typeof AuthenticatedAgentsRoute;
  "/device": typeof AuthenticatedDeviceRoute;
  "/earnings": typeof AuthenticatedEarningsRoute;
  "/evals": typeof AuthenticatedEvalsRoute;
  "/games": typeof AuthenticatedGamesRoute;
  "/ledger": typeof AuthenticatedLedgerRoute;
  "/models": typeof AuthenticatedModelsRoute;
  "/moderation": typeof AuthenticatedModerationRoute;
  "/search": typeof AuthenticatedSearchRoute;
  "/staff": typeof AuthenticatedStaffRoute;
  "/viewport-lab": typeof AuthenticatedViewportLabRoute;
  "/account/deleted": typeof AccountDeletedRoute;
  "/checkout/app-return": typeof CheckoutAppReturnRoute;
  "/": typeof AuthenticatedIndexRoute;
  "/account/deletion": typeof AuthenticatedAccountDeletionRoute;
  "/assets/mine": typeof AuthenticatedAssetsMineRoute;
  "/invites/$code": typeof AuthenticatedInvitesCodeRoute;
  "/play/$gameId": typeof AuthenticatedPlayGameIdRoute;
  "/presets/mine": typeof AuthenticatedPresetsMineRoute;
  "/profiles/$profileId": typeof AuthenticatedProfilesProfileIdRoute;
  "/settings/{-$section}": typeof AuthenticatedSettingsChar123SectionChar125Route;
  "/assets": typeof AuthenticatedAssetsIndexRoute;
  "/assets/collections/$collectionId": typeof AuthenticatedAssetsCollectionsCollectionIdRoute;
  "/assets/collections/mine": typeof AuthenticatedAssetsCollectionsMineRoute;
  "/play/$gameId/debug": typeof AuthenticatedPlayGameIdDebugRoute;
  "/presets/$slug/edit": typeof AuthenticatedPresetsSlugEditRoute;
  "/presets/$slug/new": typeof AuthenticatedPresetsSlugNewRoute;
  "/presets/$slug/still": typeof AuthenticatedPresetsSlugStillRoute;
  "/assets/$assetId": typeof AuthenticatedAssetsAssetIdIndexRoute;
  "/assets/collections": typeof AuthenticatedAssetsCollectionsIndexRoute;
  "/presets/$slug": typeof AuthenticatedPresetsSlugIndexRoute;
  "/assets/id/$assetId/edit": typeof AuthenticatedAssetsIdAssetIdEditRoute;
  "/assets/$kind/$slug": typeof AuthenticatedAssetsKindSlugIndexRoute;
  "/assets/id/$assetId/drafts/$versionId": typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/create-account": typeof CreateAccountRoute;
  "/login": typeof LoginRoute;
  "/_authenticated/@{$username}": typeof AuthenticatedAtChar123usernameChar125Route;
  "/_authenticated/agents": typeof AuthenticatedAgentsRoute;
  "/_authenticated/device": typeof AuthenticatedDeviceRoute;
  "/_authenticated/earnings": typeof AuthenticatedEarningsRoute;
  "/_authenticated/evals": typeof AuthenticatedEvalsRoute;
  "/_authenticated/games": typeof AuthenticatedGamesRoute;
  "/_authenticated/ledger": typeof AuthenticatedLedgerRoute;
  "/_authenticated/models": typeof AuthenticatedModelsRoute;
  "/_authenticated/moderation": typeof AuthenticatedModerationRoute;
  "/_authenticated/search": typeof AuthenticatedSearchRoute;
  "/_authenticated/staff": typeof AuthenticatedStaffRoute;
  "/_authenticated/viewport-lab": typeof AuthenticatedViewportLabRoute;
  "/account/deleted": typeof AccountDeletedRoute;
  "/checkout/app-return": typeof CheckoutAppReturnRoute;
  "/_authenticated/": typeof AuthenticatedIndexRoute;
  "/_authenticated/account/deletion": typeof AuthenticatedAccountDeletionRoute;
  "/_authenticated/assets/mine": typeof AuthenticatedAssetsMineRoute;
  "/_authenticated/invites/$code": typeof AuthenticatedInvitesCodeRoute;
  "/_authenticated/play/$gameId": typeof AuthenticatedPlayGameIdRoute;
  "/_authenticated/presets/mine": typeof AuthenticatedPresetsMineRoute;
  "/_authenticated/profiles/$profileId": typeof AuthenticatedProfilesProfileIdRoute;
  "/_authenticated/settings/{-$section}": typeof AuthenticatedSettingsChar123SectionChar125Route;
  "/_authenticated/assets/": typeof AuthenticatedAssetsIndexRoute;
  "/_authenticated/assets/collections/$collectionId": typeof AuthenticatedAssetsCollectionsCollectionIdRoute;
  "/_authenticated/assets/collections/mine": typeof AuthenticatedAssetsCollectionsMineRoute;
  "/_authenticated/play_/$gameId/debug": typeof AuthenticatedPlayGameIdDebugRoute;
  "/_authenticated/presets/$slug/edit": typeof AuthenticatedPresetsSlugEditRoute;
  "/_authenticated/presets/$slug/new": typeof AuthenticatedPresetsSlugNewRoute;
  "/_authenticated/presets/$slug/still": typeof AuthenticatedPresetsSlugStillRoute;
  "/_authenticated/assets/$assetId/": typeof AuthenticatedAssetsAssetIdIndexRoute;
  "/_authenticated/assets/collections/": typeof AuthenticatedAssetsCollectionsIndexRoute;
  "/_authenticated/presets/$slug/": typeof AuthenticatedPresetsSlugIndexRoute;
  "/_authenticated/assets/id/$assetId/edit": typeof AuthenticatedAssetsIdAssetIdEditRoute;
  "/_authenticated/assets/$kind/$slug/": typeof AuthenticatedAssetsKindSlugIndexRoute;
  "/_authenticated/assets/id/$assetId/drafts/$versionId": typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/create-account"
    | "/login"
    | "/@{$username}"
    | "/agents"
    | "/device"
    | "/earnings"
    | "/evals"
    | "/games"
    | "/ledger"
    | "/models"
    | "/moderation"
    | "/search"
    | "/staff"
    | "/viewport-lab"
    | "/account/deleted"
    | "/checkout/app-return"
    | "/account/deletion"
    | "/assets/mine"
    | "/invites/$code"
    | "/play/$gameId"
    | "/presets/mine"
    | "/profiles/$profileId"
    | "/settings/{-$section}"
    | "/assets/"
    | "/assets/collections/$collectionId"
    | "/assets/collections/mine"
    | "/play/$gameId/debug"
    | "/presets/$slug/edit"
    | "/presets/$slug/new"
    | "/presets/$slug/still"
    | "/assets/$assetId/"
    | "/assets/collections/"
    | "/presets/$slug/"
    | "/assets/id/$assetId/edit"
    | "/assets/$kind/$slug/"
    | "/assets/id/$assetId/drafts/$versionId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/create-account"
    | "/login"
    | "/@{$username}"
    | "/agents"
    | "/device"
    | "/earnings"
    | "/evals"
    | "/games"
    | "/ledger"
    | "/models"
    | "/moderation"
    | "/search"
    | "/staff"
    | "/viewport-lab"
    | "/account/deleted"
    | "/checkout/app-return"
    | "/"
    | "/account/deletion"
    | "/assets/mine"
    | "/invites/$code"
    | "/play/$gameId"
    | "/presets/mine"
    | "/profiles/$profileId"
    | "/settings/{-$section}"
    | "/assets"
    | "/assets/collections/$collectionId"
    | "/assets/collections/mine"
    | "/play/$gameId/debug"
    | "/presets/$slug/edit"
    | "/presets/$slug/new"
    | "/presets/$slug/still"
    | "/assets/$assetId"
    | "/assets/collections"
    | "/presets/$slug"
    | "/assets/id/$assetId/edit"
    | "/assets/$kind/$slug"
    | "/assets/id/$assetId/drafts/$versionId";
  id:
    | "__root__"
    | "/_authenticated"
    | "/create-account"
    | "/login"
    | "/_authenticated/@{$username}"
    | "/_authenticated/agents"
    | "/_authenticated/device"
    | "/_authenticated/earnings"
    | "/_authenticated/evals"
    | "/_authenticated/games"
    | "/_authenticated/ledger"
    | "/_authenticated/models"
    | "/_authenticated/moderation"
    | "/_authenticated/search"
    | "/_authenticated/staff"
    | "/_authenticated/viewport-lab"
    | "/account/deleted"
    | "/checkout/app-return"
    | "/_authenticated/"
    | "/_authenticated/account/deletion"
    | "/_authenticated/assets/mine"
    | "/_authenticated/invites/$code"
    | "/_authenticated/play/$gameId"
    | "/_authenticated/presets/mine"
    | "/_authenticated/profiles/$profileId"
    | "/_authenticated/settings/{-$section}"
    | "/_authenticated/assets/"
    | "/_authenticated/assets/collections/$collectionId"
    | "/_authenticated/assets/collections/mine"
    | "/_authenticated/play_/$gameId/debug"
    | "/_authenticated/presets/$slug/edit"
    | "/_authenticated/presets/$slug/new"
    | "/_authenticated/presets/$slug/still"
    | "/_authenticated/assets/$assetId/"
    | "/_authenticated/assets/collections/"
    | "/_authenticated/presets/$slug/"
    | "/_authenticated/assets/id/$assetId/edit"
    | "/_authenticated/assets/$kind/$slug/"
    | "/_authenticated/assets/id/$assetId/drafts/$versionId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  CreateAccountRoute: typeof CreateAccountRoute;
  LoginRoute: typeof LoginRoute;
  AccountDeletedRoute: typeof AccountDeletedRoute;
  CheckoutAppReturnRoute: typeof CheckoutAppReturnRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/create-account": {
      id: "/create-account";
      path: "/create-account";
      fullPath: "/create-account";
      preLoaderRoute: typeof CreateAccountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/": {
      id: "/_authenticated/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/@{$username}": {
      id: "/_authenticated/@{$username}";
      path: "/@{$username}";
      fullPath: "/@{$username}";
      preLoaderRoute: typeof AuthenticatedAtChar123usernameChar125RouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/agents": {
      id: "/_authenticated/agents";
      path: "/agents";
      fullPath: "/agents";
      preLoaderRoute: typeof AuthenticatedAgentsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/device": {
      id: "/_authenticated/device";
      path: "/device";
      fullPath: "/device";
      preLoaderRoute: typeof AuthenticatedDeviceRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/earnings": {
      id: "/_authenticated/earnings";
      path: "/earnings";
      fullPath: "/earnings";
      preLoaderRoute: typeof AuthenticatedEarningsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/evals": {
      id: "/_authenticated/evals";
      path: "/evals";
      fullPath: "/evals";
      preLoaderRoute: typeof AuthenticatedEvalsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/games": {
      id: "/_authenticated/games";
      path: "/games";
      fullPath: "/games";
      preLoaderRoute: typeof AuthenticatedGamesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/ledger": {
      id: "/_authenticated/ledger";
      path: "/ledger";
      fullPath: "/ledger";
      preLoaderRoute: typeof AuthenticatedLedgerRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/models": {
      id: "/_authenticated/models";
      path: "/models";
      fullPath: "/models";
      preLoaderRoute: typeof AuthenticatedModelsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/moderation": {
      id: "/_authenticated/moderation";
      path: "/moderation";
      fullPath: "/moderation";
      preLoaderRoute: typeof AuthenticatedModerationRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/search": {
      id: "/_authenticated/search";
      path: "/search";
      fullPath: "/search";
      preLoaderRoute: typeof AuthenticatedSearchRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/staff": {
      id: "/_authenticated/staff";
      path: "/staff";
      fullPath: "/staff";
      preLoaderRoute: typeof AuthenticatedStaffRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/viewport-lab": {
      id: "/_authenticated/viewport-lab";
      path: "/viewport-lab";
      fullPath: "/viewport-lab";
      preLoaderRoute: typeof AuthenticatedViewportLabRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/account/deleted": {
      id: "/account/deleted";
      path: "/account/deleted";
      fullPath: "/account/deleted";
      preLoaderRoute: typeof AccountDeletedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/checkout/app-return": {
      id: "/checkout/app-return";
      path: "/checkout/app-return";
      fullPath: "/checkout/app-return";
      preLoaderRoute: typeof CheckoutAppReturnRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/account/deletion": {
      id: "/_authenticated/account/deletion";
      path: "/account/deletion";
      fullPath: "/account/deletion";
      preLoaderRoute: typeof AuthenticatedAccountDeletionRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/": {
      id: "/_authenticated/assets/";
      path: "/assets";
      fullPath: "/assets/";
      preLoaderRoute: typeof AuthenticatedAssetsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/mine": {
      id: "/_authenticated/assets/mine";
      path: "/assets/mine";
      fullPath: "/assets/mine";
      preLoaderRoute: typeof AuthenticatedAssetsMineRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/invites/$code": {
      id: "/_authenticated/invites/$code";
      path: "/invites/$code";
      fullPath: "/invites/$code";
      preLoaderRoute: typeof AuthenticatedInvitesCodeRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/play/$gameId": {
      id: "/_authenticated/play/$gameId";
      path: "/play/$gameId";
      fullPath: "/play/$gameId";
      preLoaderRoute: typeof AuthenticatedPlayGameIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/presets/mine": {
      id: "/_authenticated/presets/mine";
      path: "/presets/mine";
      fullPath: "/presets/mine";
      preLoaderRoute: typeof AuthenticatedPresetsMineRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/profiles/$profileId": {
      id: "/_authenticated/profiles/$profileId";
      path: "/profiles/$profileId";
      fullPath: "/profiles/$profileId";
      preLoaderRoute: typeof AuthenticatedProfilesProfileIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/settings/{-$section}": {
      id: "/_authenticated/settings/{-$section}";
      path: "/settings/{-$section}";
      fullPath: "/settings/{-$section}";
      preLoaderRoute: typeof AuthenticatedSettingsChar123SectionChar125RouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/$assetId/": {
      id: "/_authenticated/assets/$assetId/";
      path: "/assets/$assetId";
      fullPath: "/assets/$assetId/";
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/collections/": {
      id: "/_authenticated/assets/collections/";
      path: "/assets/collections";
      fullPath: "/assets/collections/";
      preLoaderRoute: typeof AuthenticatedAssetsCollectionsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/collections/$collectionId": {
      id: "/_authenticated/assets/collections/$collectionId";
      path: "/assets/collections/$collectionId";
      fullPath: "/assets/collections/$collectionId";
      preLoaderRoute: typeof AuthenticatedAssetsCollectionsCollectionIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/collections/mine": {
      id: "/_authenticated/assets/collections/mine";
      path: "/assets/collections/mine";
      fullPath: "/assets/collections/mine";
      preLoaderRoute: typeof AuthenticatedAssetsCollectionsMineRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/play_/$gameId/debug": {
      id: "/_authenticated/play_/$gameId/debug";
      path: "/play/$gameId/debug";
      fullPath: "/play/$gameId/debug";
      preLoaderRoute: typeof AuthenticatedPlayGameIdDebugRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/presets/$slug/": {
      id: "/_authenticated/presets/$slug/";
      path: "/presets/$slug";
      fullPath: "/presets/$slug/";
      preLoaderRoute: typeof AuthenticatedPresetsSlugIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/presets/$slug/edit": {
      id: "/_authenticated/presets/$slug/edit";
      path: "/presets/$slug/edit";
      fullPath: "/presets/$slug/edit";
      preLoaderRoute: typeof AuthenticatedPresetsSlugEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/presets/$slug/new": {
      id: "/_authenticated/presets/$slug/new";
      path: "/presets/$slug/new";
      fullPath: "/presets/$slug/new";
      preLoaderRoute: typeof AuthenticatedPresetsSlugNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/presets/$slug/still": {
      id: "/_authenticated/presets/$slug/still";
      path: "/presets/$slug/still";
      fullPath: "/presets/$slug/still";
      preLoaderRoute: typeof AuthenticatedPresetsSlugStillRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/$kind/$slug/": {
      id: "/_authenticated/assets/$kind/$slug/";
      path: "/assets/$kind/$slug";
      fullPath: "/assets/$kind/$slug/";
      preLoaderRoute: typeof AuthenticatedAssetsKindSlugIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/id/$assetId/edit": {
      id: "/_authenticated/assets/id/$assetId/edit";
      path: "/assets/id/$assetId/edit";
      fullPath: "/assets/id/$assetId/edit";
      preLoaderRoute: typeof AuthenticatedAssetsIdAssetIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/id/$assetId/drafts/$versionId": {
      id: "/_authenticated/assets/id/$assetId/drafts/$versionId";
      path: "/assets/id/$assetId/drafts/$versionId";
      fullPath: "/assets/id/$assetId/drafts/$versionId";
      preLoaderRoute: typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAtChar123usernameChar125Route: typeof AuthenticatedAtChar123usernameChar125Route;
  AuthenticatedAgentsRoute: typeof AuthenticatedAgentsRoute;
  AuthenticatedDeviceRoute: typeof AuthenticatedDeviceRoute;
  AuthenticatedEarningsRoute: typeof AuthenticatedEarningsRoute;
  AuthenticatedEvalsRoute: typeof AuthenticatedEvalsRoute;
  AuthenticatedGamesRoute: typeof AuthenticatedGamesRoute;
  AuthenticatedLedgerRoute: typeof AuthenticatedLedgerRoute;
  AuthenticatedModelsRoute: typeof AuthenticatedModelsRoute;
  AuthenticatedModerationRoute: typeof AuthenticatedModerationRoute;
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRoute;
  AuthenticatedStaffRoute: typeof AuthenticatedStaffRoute;
  AuthenticatedViewportLabRoute: typeof AuthenticatedViewportLabRoute;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedAccountDeletionRoute: typeof AuthenticatedAccountDeletionRoute;
  AuthenticatedAssetsMineRoute: typeof AuthenticatedAssetsMineRoute;
  AuthenticatedInvitesCodeRoute: typeof AuthenticatedInvitesCodeRoute;
  AuthenticatedPlayGameIdRoute: typeof AuthenticatedPlayGameIdRoute;
  AuthenticatedPresetsMineRoute: typeof AuthenticatedPresetsMineRoute;
  AuthenticatedProfilesProfileIdRoute: typeof AuthenticatedProfilesProfileIdRoute;
  AuthenticatedSettingsChar123SectionChar125Route: typeof AuthenticatedSettingsChar123SectionChar125Route;
  AuthenticatedAssetsIndexRoute: typeof AuthenticatedAssetsIndexRoute;
  AuthenticatedAssetsCollectionsCollectionIdRoute: typeof AuthenticatedAssetsCollectionsCollectionIdRoute;
  AuthenticatedAssetsCollectionsMineRoute: typeof AuthenticatedAssetsCollectionsMineRoute;
  AuthenticatedPlayGameIdDebugRoute: typeof AuthenticatedPlayGameIdDebugRoute;
  AuthenticatedPresetsSlugEditRoute: typeof AuthenticatedPresetsSlugEditRoute;
  AuthenticatedPresetsSlugNewRoute: typeof AuthenticatedPresetsSlugNewRoute;
  AuthenticatedPresetsSlugStillRoute: typeof AuthenticatedPresetsSlugStillRoute;
  AuthenticatedAssetsAssetIdIndexRoute: typeof AuthenticatedAssetsAssetIdIndexRoute;
  AuthenticatedAssetsCollectionsIndexRoute: typeof AuthenticatedAssetsCollectionsIndexRoute;
  AuthenticatedPresetsSlugIndexRoute: typeof AuthenticatedPresetsSlugIndexRoute;
  AuthenticatedAssetsIdAssetIdEditRoute: typeof AuthenticatedAssetsIdAssetIdEditRoute;
  AuthenticatedAssetsKindSlugIndexRoute: typeof AuthenticatedAssetsKindSlugIndexRoute;
  AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute: typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAtChar123usernameChar125Route:
    AuthenticatedAtChar123usernameChar125Route,
  AuthenticatedAgentsRoute: AuthenticatedAgentsRoute,
  AuthenticatedDeviceRoute: AuthenticatedDeviceRoute,
  AuthenticatedEarningsRoute: AuthenticatedEarningsRoute,
  AuthenticatedEvalsRoute: AuthenticatedEvalsRoute,
  AuthenticatedGamesRoute: AuthenticatedGamesRoute,
  AuthenticatedLedgerRoute: AuthenticatedLedgerRoute,
  AuthenticatedModelsRoute: AuthenticatedModelsRoute,
  AuthenticatedModerationRoute: AuthenticatedModerationRoute,
  AuthenticatedSearchRoute: AuthenticatedSearchRoute,
  AuthenticatedStaffRoute: AuthenticatedStaffRoute,
  AuthenticatedViewportLabRoute: AuthenticatedViewportLabRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAccountDeletionRoute: AuthenticatedAccountDeletionRoute,
  AuthenticatedAssetsMineRoute: AuthenticatedAssetsMineRoute,
  AuthenticatedInvitesCodeRoute: AuthenticatedInvitesCodeRoute,
  AuthenticatedPlayGameIdRoute: AuthenticatedPlayGameIdRoute,
  AuthenticatedPresetsMineRoute: AuthenticatedPresetsMineRoute,
  AuthenticatedProfilesProfileIdRoute: AuthenticatedProfilesProfileIdRoute,
  AuthenticatedSettingsChar123SectionChar125Route:
    AuthenticatedSettingsChar123SectionChar125Route,
  AuthenticatedAssetsIndexRoute: AuthenticatedAssetsIndexRoute,
  AuthenticatedAssetsCollectionsCollectionIdRoute:
    AuthenticatedAssetsCollectionsCollectionIdRoute,
  AuthenticatedAssetsCollectionsMineRoute:
    AuthenticatedAssetsCollectionsMineRoute,
  AuthenticatedPlayGameIdDebugRoute: AuthenticatedPlayGameIdDebugRoute,
  AuthenticatedPresetsSlugEditRoute: AuthenticatedPresetsSlugEditRoute,
  AuthenticatedPresetsSlugNewRoute: AuthenticatedPresetsSlugNewRoute,
  AuthenticatedPresetsSlugStillRoute: AuthenticatedPresetsSlugStillRoute,
  AuthenticatedAssetsAssetIdIndexRoute: AuthenticatedAssetsAssetIdIndexRoute,
  AuthenticatedAssetsCollectionsIndexRoute:
    AuthenticatedAssetsCollectionsIndexRoute,
  AuthenticatedPresetsSlugIndexRoute: AuthenticatedPresetsSlugIndexRoute,
  AuthenticatedAssetsIdAssetIdEditRoute: AuthenticatedAssetsIdAssetIdEditRoute,
  AuthenticatedAssetsKindSlugIndexRoute: AuthenticatedAssetsKindSlugIndexRoute,
  AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute:
    AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CreateAccountRoute: CreateAccountRoute,
  LoginRoute: LoginRoute,
  AccountDeletedRoute: AccountDeletedRoute,
  CheckoutAppReturnRoute: CheckoutAppReturnRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
